"use client";

import dynamic from "next/dynamic";
import type { AudioBookProps } from "./AudioBook";

const AudioBook = dynamic(() => import("./AudioBook"));

export default function AudioBookLazy(props: AudioBookProps) {
  return <AudioBook {...props} />;
}
